var exports = {
  "zr": "x620889e6--0fb43d--root",
  "PQ": "x620889e6--0fb43d--border",
  "Lw": "x620889e6--0fb43d--overlay",
  "nf": "x620889e6--0fb43d--link",
  "Sl": "x620889e6--0fb43d--image",
  "DD": "x620889e6--0fb43d--title",
  "sR": "x620889e6--0fb43d--selected-item",
  "Vt": "x620889e6--0fb43d--prices",
  "bJ": "x620889e6--0fb43d--price-list",
  "x6": "x620889e6--0fb43d--button",
};

module.exports = exports;
